import React, { useEffect, useState } from "react";
import c from "./styles.module.scss";

const Pagination = ({
	active,
	from,
	to,
	onPreviousPage,
	onNextPage,
	onChoosePage,
}) => {
	const [visibleRange, setVisibleRange] = useState(getVisibleRange());

	useEffect(() => {
		function handleResize() {
			setVisibleRange(getVisibleRange());
		}

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	function getVisibleRange() {
		return window.innerWidth < 768 ? 3 : 5;
	}

	const items = [];

	let start = Math.max(from, active - Math.floor(visibleRange / 2));
	let end = Math.min(to, start + visibleRange - 1);
	start = Math.max(from, end - visibleRange + 1);

	if (start > from) {
		items.push(
			<div key={`page-${from}`} className={c.item} onClick={() => onChoosePage(from)}>
				{from}
			</div>
		);
	}

	if (start > from + 1) {
		items.push(
			<div key="ellipsis-left" className={c.elipsis}>
				...
			</div>
		);
	}

	for (let i = start; i <= end; i++) {
		items.push(
			<div
				key={`page-${i}`}
				className={[c.item, i === active ? c.active : null].join(" ")}
				onClick={() => onChoosePage(i)}
			>
				{i}
			</div>
		);
	}

	if (end < to - 1) {
		items.push(
			<div key="ellipsis-right" className={c.elipsis}>
				...
			</div>
		);
	}

	if (to > end) {
		items.push(
			<div key={`page-${to}`} className={c.item} onClick={() => onChoosePage(to)}>
				{to}
			</div>
		);
	}

	return (
		<div className={c.pagination}>
			{active !== from ? (
				<div
					className={[c.item, c.arrow, "icon-arrow-left"].join(" ")}
					onClick={onPreviousPage}
				></div>
			) : null}
			{items}
			{active !== to ? (
				<div
					className={[c.item, c.arrow, "icon-arrow-right"].join(" ")}
					onClick={onNextPage}
				></div>
			) : null}
		</div>
	);
};

export default Pagination;
